<template>
  <div>
    <div class="vx-row mt-0">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label pl-1">Current DO Reference</label>
        <vs-input
          class="w-full"
          v-model="old_do_reference"
          placeholder="Enter current DO reference"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label pl-1">New Outbound Reference</label>
        <vs-input
          class="w-full"
          v-model="new_outbound_reference"
          placeholder="Enter new outbound reference"
          @keyup.enter="submitForm"
        />
      </div>
    </div>

    <!-- Submit Button -->
    <div class="vx-row mt-5">
      <div class="vx-col md:w-1/4 w-full">
        <vs-button
          color="primary"
          class="btn"
          @click="submitForm"
          :disabled="!canSubmit"
        >
          Process
        </vs-button>
      </div>
    </div>

    <!-- Confirm Modal -->
    <vs-popup title="Konfirmasi Change Delivery Order's Outbound" :active.sync="showConfirmModal">
      <p style="margin-bottom:12px;">Apakah kamu yakin ingin memperbarui outbound reference untuk delivery order ini?</p>
      <table style="width:100%;margin-bottom:16px;">
        <tr>
          <td style="padding:4px 0;font-weight:bold;width:40%;">DO Reference (Old)</td>
          <td style="padding:4px 0;">{{ old_do_reference }}</td>
        </tr>
        <tr>
          <td style="padding:4px 0;font-weight:bold;">Outbound Reference (New)</td>
          <td style="padding:4px 0;">{{ new_outbound_reference }}</td>
        </tr>
      </table>
      <div style="display:flex;justify-content:flex-end;">
        <vs-button color="grey" class="btn mr-2" @click="showConfirmModal = false">Batal</vs-button>
        <vs-button color="primary" class="btn" @click="confirmUpdate">Ya, Update</vs-button>
      </div>
    </vs-popup>

    <!-- Result Section -->
    <div class="vx-row mt-10" v-if="result">
      <div class="vx-col md:w-full w-full">
        <div style="font-size:14px;font-weight:700;margin-bottom:12px;">Hasil Update:</div>
        <div style="border:1px solid #ddd;border-radius:4px;overflow:hidden;">
          <div class="vx-row" style="border-bottom:1px solid #ddd;">
            <div class="vx-col md:w-1/2" style="border-right:1px solid #ddd;padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:14px;font-weight:600;">OLD DO NUMBER</span>
            </div>
            <div class="vx-col md:w-1/2" style="padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:14px;font-weight:600;">NEW DO NUMBER</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2" style="border-right:1px solid #ddd;padding:12px 16px;">
              <span style="font-size:14px;">{{ result.old_do_number }}</span>
            </div>
            <div class="vx-col md:w-1/2" style="padding:12px 16px;">
              <span style="font-size:14px;">{{ result.new_do_number }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChangeOutboundDeliveryOrder",
  data() {
    return {
      old_do_reference: "",
      new_outbound_reference: "",
      showConfirmModal: false,
      result: null,
    };
  },
  computed: {
    canSubmit() {
      return this.old_do_reference.trim() !== "" && this.new_outbound_reference.trim() !== "";
    },
  },
  methods: {
    submitForm() {
      if (!this.canSubmit) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "DO Reference dan Outbound Reference wajib diisi.",
        });
        return false;
      }
      this.showConfirmModal = true;
    },
    confirmUpdate() {
      this.showConfirmModal = false;
      this.$emit("loading", true);

      this.$http
        .post("support/outbound/deliveryorder/change-outbound", {
          old_do_reference: this.old_do_reference,
          new_outbound_reference: this.new_outbound_reference,
        })
        .then((res) => {
          this.$emit("loading", false);
          this.result = res.data.data;
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: res.data.message || `Outbound reference berhasil diperbarui.`,
          });
          this.old_do_reference = "";
          this.new_outbound_reference = "";
        })
        .catch((error) => this.$emit("error", error));
    },
  },
};
</script>
